import {
  LuSmartphone,
  LuClock,
  LuBuilding2,
  LuUsers,
  LuWallet,
  LuCpu,
  LuClipboardList,
  LuPalette,
  LuCode,
  LuBug,
  LuRocket,
  LuSettings,
  LuShieldCheck,
  LuShield,
  LuPercent,
} from "react-icons/lu";

export const BrandStrategyHeroData = {
  backgroundImage: "/images/serviceBanners/BRANDSTRATEGYPOSITIONING.webp",
  whiteImage: "/images/serviceBanners/BRAND STRATEGY POSITIONINGWhite.webp",
  subTitle: "Brand Strategy & Positioning Services",
  title: (
    <>
      High Performance <br /> <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">Brand Identity</span> System
    </>
  ),
  description:
    "We build strong brand strategy and positioning systems that enhance market recognition, improve audience perception, and drive long term business growth through structured planning, consistent messaging, and strategic brand development.",
  primaryButton: {
    title: "Get a Free Quote",
    onClick: () => console.log("Get a Free Quote clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("View Our Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "Brand Identity Development",
      desc: "Create unique brand identity including logo, typography, color system, and visual language.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Market Positioning Strategy",
      desc: "Define clear positioning based on audience, competitors, and unique value proposition.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Consistent Brand Communication",
      desc: "Develop consistent messaging, tone, and storytelling across all customer touchpoints.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Scalable Brand Systems",
      desc: "Build structured brand systems that ensure scalability and consistency across products.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/nodejs.webp",
      top: "16%",
      right: "8%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
  ],
};

export const brandStrategyStatsData = [
  {
    icon: LuSettings,
    value: "120+",
    label: "Strategies Defined",
    colorClass: "text-[#00d2ff]",
    bgClass: "bg-[#00d2ff]/10",
    borderClass: "border-[#00d2ff]/20",
    glowClass: "shadow-[0_0_20px_rgba(0,210,255,0.15)]",
  },
  {
    icon: LuUsers,
    value: "85+",
    label: "Partners Positioned",
    colorClass: "text-[#a855f7]",
    bgClass: "bg-[#a855f7]/10",
    borderClass: "border-[#a855f7]/20",
    glowClass: "shadow-[0_0_20px_rgba(168,85,247,0.15)]",
  },
  {
    icon: LuSmartphone,
    value: "30M+",
    label: "Market Reach",
    colorClass: "text-[#06b6d4]",
    bgClass: "bg-[#06b6d4]/10",
    borderClass: "border-[#06b6d4]/20",
    glowClass: "shadow-[0_0_20px_rgba(6,182,212,0.15)]",
  },
  {
    icon: LuShieldCheck,
    value: "99.9%",
    label: "Market Alignment",
    colorClass: "text-[#3b82f6]",
    bgClass: "bg-[#3b82f6]/10",
    borderClass: "border-[#3b82f6]/20",
    glowClass: "shadow-[0_0_20px_rgba(59,130,246,0.15)]",
  },
  {
    icon: LuPercent,
    value: "45%",
    label: "Trust Increase",
    colorClass: "text-[#d946ef]",
    bgClass: "bg-[#d946ef]/10",
    borderClass: "border-[#d946ef]/20",
    glowClass: "shadow-[0_0_20px_rgba(217,70,239,0.15)]",
  },
  {
    icon: LuShield,
    value: "100%",
    label: "Growth Focus",
    colorClass: "text-[#6366f1]",
    bgClass: "bg-[#6366f1]/10",
    borderClass: "border-[#6366f1]/20",
    glowClass: "shadow-[0_0_20px_rgba(99,102,241,0.15)]",
  },
];

export const brandStrategySolutionsAndProcessData = {
  buildSubtitle: "WHAT WE DELIVER",
  buildTitle: "Brand Strategy & Positioning Solutions for Every Business Requirement",
  buildCards: [
    {
      title: "Brand Identity Development",
      desc: "Create unique brand identity including logo, typography, color system, and visual language that defines your business presence.",
      icon: LuSmartphone,
      colorClass: "text-[#00d2ff]",
      bgClass: "bg-[#00d2ff]/10",
      borderClass: "border-[#00d2ff]/20 hover:border-[#00d2ff]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(0,210,255,0.25)]",
    },
    {
      title: "Market Positioning Strategy",
      desc: "Define clear positioning based on audience, competitors, and unique value proposition.",
      icon: LuClock,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "Brand Communication System",
      desc: "Develop consistent messaging, tone, and storytelling across all customer touchpoints.",
      icon: LuBuilding2,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "Brand Architecture Design",
      desc: "Build structured brand systems that ensure scalability and consistency across products and services.",
      icon: LuUsers,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "Brand Performance Optimization",
      desc: "Improve brand perception, visibility, and market impact using data-driven insights.",
      icon: LuWallet,
      colorClass: "text-[#6366f1]",
      bgClass: "bg-[#6366f1]/10",
      borderClass: "border-[#6366f1]/20 hover:border-[#6366f1]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(99,102,241,0.25)]",
    },
    {
      title: "Enterprise Brand Solutions",
      desc: "Design scalable branding systems for large and complex business environments.",
      icon: LuCpu,
      colorClass: "text-[#d946ef]",
      bgClass: "bg-[#d946ef]/10",
      borderClass: "border-[#d946ef]/20 hover:border-[#d946ef]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(217,70,239,0.25)]",
    },
  ],
  processSubtitle: "Brand Engineering Framework",
  processTitle: "How We Build Scalable Brand Systems",
  processSteps: [
    {
      step: "01",
      title: "Brand Architecture Planning",
      description: "Define brand structure, positioning roadmap, and long-term growth direction.",
      icon: LuUsers,
    },
    {
      step: "02",
      title: "Agile Brand Development",
      description: "Execute brand building in iterative cycles for continuous improvement and refinement.",
      icon: LuClipboardList,
    },
    {
      step: "03",
      title: "Brand Identity System Development",
      description: "Create scalable brand elements including visual identity, messaging, and communication systems.",
      icon: LuPalette,
    },
    {
      step: "04",
      title: "Brand Communication Management",
      description: "Ensure consistent storytelling, tone, and messaging across all channels.",
      icon: LuCode,
    },
    {
      step: "05",
      title: "Brand Performance Optimization",
      description: "Improve brand visibility, perception, and market positioning using insights and analysis.",
      icon: LuBug,
    },
    {
      step: "06",
      title: "Quality Assurance & Consistency",
      description: "Maintain brand consistency across all platforms, teams, and customer touchpoints.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "WHY INVEST IN BRAND STRATEGY SYSTEMS?",
  benefitsTitle: "Why Businesses Invest in Brand Strategy Systems",
  benefits: [
    "Strong market positioning",
    "Consistent brand identity",
    "Better customer trust and recognition",
    "Scalable communication system",
    "Long-term brand authority building",
    "Competitive advantage in market",
    "Sustainable business growth",
  ],
  logoImage: "/images/serviceBanners/DigitalMarketingLatest.webp",
  whiteLogoImage: "/images/serviceBanners/digitalMarketingLatestW.webp",
};

export const brandStrategyPortfolioData = {
  subtitle: "OUR WORK",
  title: "Brand Strategy Campaigns We're Proud Of",
  buttonText: "View Case Studies",
  buttonLink: "#all-projects",
  apps: [
    {
      title: "Foodie Express",
      badge: "Food Delivery App",
      badgeColor: "bg-[#00d2ff]/10 text-[#00d2ff] border-[#00d2ff]/20",
      desc: "A fast and intuitive food delivery app with real-time tracking, secure payments & smooth experience.",
      downloads: "100K+",
      rating: "4.8",
      image: "/images/MobileAppDevelopment/foodie_express.png",
    },
    {
      title: "FinMate",
      badge: "FinTech App",
      badgeColor: "bg-[#a855f7]/10 text-[#a855f7] border-[#a855f7]/20",
      desc: "A personal finance app to manage expenses, budgets & investments with advanced analytics.",
      downloads: "250K+",
      rating: "4.9",
      image: "/images/MobileAppDevelopment/finmate.png",
    },
    {
      title: "TravelGo",
      badge: "Travel App",
      badgeColor: "bg-[#3b82f6]/10 text-[#3b82f6] border-[#3b82f6]/20",
      desc: "A travel booking app for flights, hotels & packages with best deals and easy bookings.",
      downloads: "500K+",
      rating: "4.7",
      image: "/images/MobileAppDevelopment/travelgo.png",
    },
  ],
};

export const brandStrategyTechnologiesData = {
  techTitle: "OUR BRAND STRATEGY STACK",
  technologies: [
    { name: "Brand Guidelines", icon: "Search" },
    { name: "Figma", icon: "Provider" },
    { name: "Adobe Photoshop", icon: "Vite" },
    { name: "Adobe Illustrator", icon: "Palette" },
  ],
  trustTitle: "TRUSTED BY GOOGLE PARTNERS",
  trustClients: [
    { image: "/images/logo/google_logo.png", alt: "google_logo" },
    { image: "/images/logo/microsoft_logo.png", alt: "microsoft_logo" },
    { image: "/images/logo/amazon_logo.png", alt: "amazon_logo" },
    { image: "/images/logo/Adobe_Corporate_logo.png", alt: "adobe_logo" },
    { image: "/images/logo/IBM_logo.png", alt: "ibm_logo" },
    { image: "/images/logo/Oracle_logo.png", alt: "oracle_logo" },
  ],
};

export const brandStrategyAboutData = [
  {
    title: "Brand Strategy Services for Building Strong Market Presence",
    content: (
      <>
        A successful brand begins with a clear strategy that aligns business goals with customer expectations. Professional Brand Strategy Services help organizations define their
        direction, strengthen market perception, and create meaningful connections with their audience. Many businesses struggle to stand out because their messaging and identity
        lack focus. At <b className="text-text-primary font-semibold">Tycho Technologies</b>, strategic branding frameworks are developed through market insights, audience
        understanding, and business objectives to help companies establish a strong and recognizable presence that supports long term growth.
      </>
    ),
  },
  {
    title: "Brand Positioning Services That Differentiate Your Business",
    content: (
      <>
        Customers are constantly exposed to competing products and services, making differentiation more important than ever. Effective Brand Positioning Services help businesses
        communicate their unique value and create a memorable place in the minds of potential customers. Organizations that invest in strategic positioning often experience
        stronger customer trust and improved brand recall. Tycho Technologies focuses on creating positioning strategies that align business strengths with audience needs, helping
        brands build credibility and maintain relevance in competitive markets.
      </>
    ),
  },
  {
    title: "Brand Identity Design Services for Lasting Recognition",
    content: (
      <>
        A strong identity helps customers instantly recognize and connect with a business. Professional Brand Identity Design Services support organizations in creating visual and
        communication elements that reflect their values and purpose. Companies that maintain a consistent identity across customer touchpoints often strengthen brand recognition
        and improve engagement. A well-defined identity also creates a foundation for future marketing efforts, helping businesses communicate with clarity and confidence across
        different channels.
      </>
    ),
  },
  {
    title: "Why Businesses Invest in Brand Development Services",
    content: (
      <>
        The demand for expert Brand Development Services continues to grow as organizations seek stronger customer relationships and sustainable market growth. Businesses that
        invest in Brand Consulting Services often gain a clearer understanding of their audience, competitive environment, and growth opportunities. Companies partnering with Tycho
        Technologies receive customized branding solutions designed around measurable business objectives and long term success. A strategic branding approach helps organizations
        improve visibility, strengthen trust, and create lasting value in an increasingly competitive marketplace.
      </>
    ),
  },
];

export const brandStrategyFaqData = [
  {
    q: "What is the difference between brand strategy and brand positioning?",
    a: "Brand strategy defines the overall direction, goals, and identity of a brand, while brand positioning focuses on how the brand is perceived by customers compared to competitors. Both work together to create a strong market presence.",
  },
  {
    q: "How do businesses know if their current brand positioning is effective?",
    a: "Businesses can evaluate brand positioning through customer feedback, brand awareness studies, market perception analysis, competitor comparisons, and audience engagement metrics to determine whether their message resonates with the right customers.",
  },
  {
    q: "Why is a consistent brand communication system important for business growth?",
    a: "A consistent brand communication system ensures that customers receive the same message, tone, and experience across all channels. This strengthens trust, improves brand recognition, and helps businesses build stronger customer relationships over time.",
  },
  {
    q: "How does Tycho Technologies develop a brand strategy tailored to business goals?",
    a: "Tycho Technologies combines market research, audience insights, competitive analysis, and business objectives to create customized brand strategies that support growth, strengthen positioning, and improve long-term brand performance.",
  },
  {
    q: "What makes Tycho Technologies a reliable partner for brand strategy and positioning services?",
    a: "Tycho Technologies focuses on building scalable brand systems, clear positioning frameworks, and consistent communication strategies that help businesses improve visibility, strengthen customer trust, and achieve sustainable market growth.",
  },
];
